import { render, staticRenderFns } from "./UserOnline.vue?vue&type=template&id=701d855d&"
import script from "./UserOnline.vue?vue&type=script&lang=ts&"
export * from "./UserOnline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports